import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  TextField,
  Button,
  Box,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../context/auth";
import { useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { toast } from "react-toastify";
import axios from "axios";
import CustomTextField from "./CustomTextField";
import { strongPasswordSchema } from "../utils/passwordValidation";

const errorTextStyle = {
  backgroundColor: "#00000075",
  color: "red",
  padding: "5px",
  borderRadius: "5px",
};

const ResetPassForm = ({ code }) => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [showPass, setShowPass] = useState(false);
  const [showConfPass, setShowConfPass] = useState(false);
  const { login } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClickShowPassword = () => setShowPass((show) => !show);
  const handleClickShowConfPassword = () => setShowConfPass((show) => !show);
  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };
  const handleMouseDownConfPassword = (e) => {
    e.preventDefault();
  };

  const registerForm = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: strongPasswordSchema("Please enter your password"),
      confirmPassword: Yup.string()
        .required("Please confirm password")
        .oneOf([Yup.ref("password"), null], "Password must match"),
    }),
    validateOnChange: true,
    validateOnBlur: false,
    onSubmit: async (values, action) => {
      try {
        setLoading(true);

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL_USER}/resetPassword`,
          {
            code,
            password: values.password,
          }
        );

        if (response?.data?.success) {
          toast.success(response?.data?.message);
          navigate("/login");
        } else {
          toast.error(response?.data?.message);
        }

        // setUser(data);
      } catch (error) {
        // toast.error(error.message);
        if (error?.response) {
          toast.error(error?.response?.data?.message);
        } else {
          toast.error(error.message);
        }
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Box className="form_wrapper ">
      <Box className="form_inner">
        <Typography component="h2" className="form_head">
          Reset your password
        </Typography>
        {/* <Typography component="p" className="form_sub_head">
        Join us to start sharing and voting today!
      </Typography> */}
        <form onSubmit={registerForm.handleSubmit}>
          <Box className="form">
            <CustomTextField
              id="outlined-start-adornment"
              // label="Outlined"
              name="password"
              variant="outlined"
              className="register_field"
              placeholder="Password"
              type={showPass ? "text" : "password"}
              value={registerForm.values.password}
              onChange={registerForm.handleChange}
              error={
                registerForm.touched.password &&
                Boolean(registerForm.errors.password)
              }
              helperText={
                registerForm.touched.password &&
                Boolean(registerForm.errors.password) && (
                  <span style={errorTextStyle}>
                    {registerForm.errors.password}
                  </span>
                )
              }
              InputProps={{
                // <-- This is where the toggle button is added.
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPass ? (
                        <Visibility sx={{ color: "white" }} />
                      ) : (
                        <VisibilityOff sx={{ color: "white" }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <CustomTextField
              id="outlined-basic"
              // label="Outlined"
              name="confirmPassword"
              variant="outlined"
              className="register_field"
              placeholder="Confirm Password"
              type={showConfPass ? "text" : "password"}
              value={registerForm.values.confirmPassword}
              onChange={registerForm.handleChange}
              error={
                registerForm.touched.confirmPassword &&
                Boolean(registerForm.errors.confirmPassword)
              }
              helperText={
                registerForm.touched.confirmPassword &&
                Boolean(registerForm.errors.confirmPassword) && (
                  <span style={errorTextStyle}>
                    {registerForm.errors.confirmPassword}
                  </span>
                )
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowConfPassword}
                      onMouseDown={handleMouseDownConfPassword}
                    >
                      {showConfPass ? (
                        <Visibility sx={{ color: "white" }} />
                      ) : (
                        <VisibilityOff sx={{ color: "white" }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button className="Register" type="submit">
              Reset Password
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default ResetPassForm;
